import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';

import { ExternalCalibration } from 'interfaces';

export const externalCalibrationService = {
  create(calibration: ExternalCalibration) {
    return axiosService
      .post(AXIOS_URLS.external_calibrations, calibration)
      .then((res) => res.data);
  },
  findBySerialNumber: (sn: string) =>
    axiosService
      .get(`${AXIOS_URLS.external_calibrations}/serial-number/${sn}`)
      .then((res) => res.data),
  findByCertificateNumber: (sn: string) =>
    axiosService
      .get(`${AXIOS_URLS.external_calibrations}/certificate-number/${sn}`)
      .then((res) => res.data),
  update: (data: ExternalCalibration) =>
    axiosService
      .patch(`${AXIOS_URLS.external_calibrations}/update`, data)
      .then((res) => res.data),
  excel: () =>
    axiosService
      .get(`${AXIOS_URLS.external_calibrations}/excel`, {
        responseType: 'blob',
      })
      .then((res) => res.data),
  getByUser: () =>
    axiosService.get(AXIOS_URLS.external_calibrations).then((res) => res.data),
};
